// src/admin/auth/AuthContext.tsx
import { createContext } from 'react';
import type { Session, User } from '@supabase/supabase-js';
import type { Database } from '@/lib/database.types';

export type AdminRole = Database['public']['Enums']['admin_role'];
export type AdminRow = Database['public']['Tables']['admin_users']['Row'];

export interface AuthContextValue {
  session: Session | null;
  user: User | null;
  admin: AdminRow | null;
  aal: 'aal1' | 'aal2' | null;
  status: 'loading' | 'signed_out' | 'signed_in';
  signOut: () => Promise<void>;
  refresh: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
